import { memo, useEffect, useRef } from "react";
import { ECharts } from "echarts";
import * as echarts from "echarts";
import moment from "moment";
import EventManager from "../../common/event-manager/EventManager";
import { ChartWrapper, DeviceMetricsWrapper, EChartsWrapper } from "./DeviceMetricsGuage.styled";

interface DeviceMetricGuageProps {
    eventManager: EventManager,
    property: any,
}

const DeviceMetricsGuage: React.FC<DeviceMetricGuageProps> = (props)=> {
    // ref
    let echartsDomsRef = useRef<HTMLElement>(null);
    let echartsRef =useRef<ECharts>(null);

    // functions
    let onRealtimeDeviceMetricsSeriesUpdated = async (deviceMetricsSeriesList: any[])=> {
        let property = props.property;
        let seriesDatas = [];
        let deviceMetricsSeries = deviceMetricsSeriesList.find(deviceMetricsSeries => deviceMetricsSeries.property.key == property.key);
        if (deviceMetricsSeries == null) {
            return;
        }

        let metrics = deviceMetricsSeries.metrics;
        let latestMetric = metrics[metrics.length - 1];
        if (echartsRef.current != null) {
            try {
                echartsRef.current.setOption({
                    series: [{
                        data: [{value: Number(latestMetric.value)}]
                    }, {
                        data: [{value: Number(latestMetric.value)}]
                    }]
                });
            } catch (e) {
                console.log(e);
            }
        }
    };

    let formatTimestampAxis = (value)=> {
        let text = moment(value).format('HH:mm:ss');
        return text;
    }

    // initialize ECharts wrapper dom
    let initializeWrapperDom = (dom)=> {
        if (dom == null) {
            return;
        }
        resizeEcharts();
    }

    // init ECharts
    let initECharts = (dom: HTMLElement)=> {
        if (dom == null) {
            // element unmount event
            let echarts = echartsRef.current;
            echarts?.dispose();
            echartsRef.current = null;
            return;
        }
        if (echarts.getInstanceByDom(dom)) {
            return;
        }

        // save to reference
        echartsDomsRef.current=dom;

        // init echarts
        let chart = echarts.init(dom);
        echartsRef.current=chart;

        // series
        let property = props.property

        // init options
        let options = {
            series: [
                {
                    type: 'gauge',
                    center: ['50%', '90%'],
                    radius: '120%',
                    startAngle: 180,
                    endAngle: 0,
                    min: Number(property.min),
                    max: Number(property.max),
                    splitNumber: 5,
                    itemStyle: {
                        color: '#FFAB91'
                    },
                    progress: {
                        show: true,
                        width: 20
                    },
                    pointer: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            width: 20
                        }
                    },
                    axisTick: {
                        distance: -30,
                        lineStyle: {
                            width: 2,
                            color: '#999'
                        }
                    },
                    splitLine: {
                        distance: -30,
                        length: 10,
                        lineStyle: {
                            width: 3,
                            color: '#999'
                        }
                    },
                    axisLabel: {
                        distance: -20,
                        color: '#999',
                        fontSize: 14,
                    },
                    anchor: {
                        show: false
                    },
                    title: {
                        show: false
                    },
                    detail: {
                        valueAnimation: true,
                        width: '60%',
                        lineHeight: 40,
                        borderRadius: 8,
                        offsetCenter: [0, 0],
                        fontSize: 24,
                        fontWeight: 'bolder',
                        formatter: '{value} ' + property.unit,
                        color: 'inherit',
                    },
                    data: [
                        {
                            value: 0
                        }
                    ]
                },
                {
                    type: 'gauge',
                    center: ['50%', '90%'],
                    startAngle: 180,
                    endAngle: 0,
                    radius: '120%',
                    min: Number(property.min),
                    max: Number(property.max),
                    itemStyle: {
                        color: '#FD7347'
                    },
                    progress: {
                        show: true,
                        width: 8
                    },
                    pointer: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    detail: {
                        show: false
                    },
                    data: [
                        {
                            value: 0
                        }
                    ]
                }
            ]
        };
        chart.setOption(options);
    }

    let resizeEcharts = ()=> {
        echartsRef.current?.resize();
    };

    // init ECharts reference
    let initEChartsRef = useRef(initECharts);

    // effect
    useEffect(()=> {
        props.eventManager.addRealtimeDeviceMetricsSeriesUpdatedListener(onRealtimeDeviceMetricsSeriesUpdated);
        window.addEventListener('resize', resizeEcharts);

        // unload
        return ()=> {
            props.eventManager.removeRealtimeDeviceMetricsSeriesUpdatedListener(onRealtimeDeviceMetricsSeriesUpdated);
            window.removeEventListener('resize', resizeEcharts);
        }
    }, []);

    // render
    return (
        <DeviceMetricsWrapper ref={(dom)=> initializeWrapperDom(dom)}>
            <ChartWrapper>
                <EChartsDom refCallback={initEChartsRef.current} />
            </ChartWrapper>
        </DeviceMetricsWrapper>
    )
}

interface EChartsDomProps {
    refCallback: (dom: HTMLDivElement)=> void;
}

let EChartsDom: React.FC<EChartsDomProps> = memo((props)=> {
    return <EChartsWrapper ref={(dom)=> props.refCallback(dom)}>
    </EChartsWrapper>
});


export default DeviceMetricsGuage;
